var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8814 1.51545H13.6391C14.4726 1.51545 15.1545 2.19741 15.1545 3.03091V15.1545C15.1545 15.988 14.4726 16.67 13.6391 16.67H1.51545C0.681955 16.67 0 15.988 0 15.1545V3.03091C0 2.19741 0.681955 1.51545 1.51545 1.51545H2.27318V0.757727C2.27318 0.340977 2.61416 0 3.03091 0C3.44766 0 3.78864 0.340977 3.78864 0.757727V1.51545H11.3659V0.757727C11.3659 0.340977 11.7069 0 12.1236 0C12.5404 0 12.8814 0.340977 12.8814 0.757727V1.51545ZM2.27348 15.1543H12.8817C13.2984 15.1543 13.6394 14.8133 13.6394 14.3965V5.3038H1.51575V14.3965C1.51575 14.8133 1.85673 15.1543 2.27348 15.1543Z",
    fill: "#2F80ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.cacd9a408a7051a1df293a91c1236054.svg";
export { ForwardRef as ReactComponent };